(() => {
  function init(root) {
    const node = root.querySelector('[data-vc-config]');
    if (!node) return;
    const CONFIG = JSON.parse(node.textContent);
    const commission = Number(CONFIG.commission);
    const aov = Number(CONFIG.aov);
    const validNumbers = Number.isFinite(commission) && commission >= 0 && commission <= 100 && Number.isFinite(aov) && aov >= 0;
    root.querySelectorAll('[data-commission]').forEach(el => el.textContent = validNumbers ? commission + '%' : '—');
    root.querySelectorAll('[data-sample-earning]').forEach(el => el.textContent = validNumbers ? (aov * commission / 100).toLocaleString('sv-SE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '—');
    let destination = null;
    try {
      const url = new URL(CONFIG.trybeUrl);
      if (url.protocol === 'https:' && !url.username && !url.password && (url.hostname === 'jointrybe.com' || url.hostname.endsWith('.jointrybe.com'))) destination = url.href;
    } catch (_) { /* Blank/unconfigured destinations fail closed. */ }
    root.querySelectorAll('[data-trybe]').forEach(el => {
      if (destination) {
        el.href = destination;
        el.target = '_blank';
        el.rel = 'noopener noreferrer';
        el.removeAttribute('aria-disabled');
        el.removeAttribute('aria-describedby');
        el.removeAttribute('title');
      } else {
        el.removeAttribute('href');
        el.removeAttribute('target');
        el.setAttribute('aria-disabled', 'true');
        el.title = 'Trybe-inbjudan är inte konfigurerad i det här utkastet.';
      }
      if (!el.dataset.vcBound) {
        el.addEventListener('click', event => {
          if (el.getAttribute('aria-disabled') === 'true') event.preventDefault();
        });
        el.addEventListener('keydown', event => {
          if (el.getAttribute('aria-disabled') === 'true' && (event.key === 'Enter' || event.key === ' ')) event.preventDefault();
        });
        el.dataset.vcBound = 'true';
      }
    });
    root.querySelectorAll('[data-trybe-status]').forEach(el => el.hidden = Boolean(destination));
  }
  const initAll = () => document.querySelectorAll('[data-vc-creators]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
